import React, { useCallback } from "react";
import PostHooks from "../../Api/PostHooks";
import { useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import AlertComponent from "../../Components/AlertComponent";
import FormNumberInput from "../../Components/FormNumberInput";

const FundPoolForm = ({ user, onClose, onSuccess }) => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
    },
    mode: "onChange",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [poolBasketOpt, setPoolBasketOpt] = useState();
  const [poolBasket, setPoolBasket] = useState();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [fundPoolLoading, fundReq, fundPoolRequest] = PostHooks();
  const [loading, response, request] = FetchHook();

  const fetchData = useCallback(() => {
    request({
      url: `/pool_basket?status=active`,
    });
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (response && response.status === 200 && response.data.StatusCode === 0) {
      setPoolBasketOpt(response.data.Data);
    }
  }, [response]);

  const fundPool = async (e) => {
    try {
      let formData = {
        entity_id: user.id,
        amount: e.amount,
        pool_fund_basket_id: poolBasket.id,
      };

      const fundReq = await fundPoolRequest({
        url: "/fund_pool_fund",
        body: formData,
      });

      if (fundReq && fundReq.status === 200 && fundReq.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Fund successful!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          fundReq?.data?.StatusMessage ??
          fundReq?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("fund pool err", error);
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const maxAmount = poolBasket
    ? (Number(poolBasket?.expected_contribution) || 0) -
      (Number(poolBasket?.contributions) || 0)
    : 0;

  return (
    <form onSubmit={handleSubmit(fundPool)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
      >
        <InputLabel id="pool_account">Pool basket</InputLabel>
        <Select
          labelId="pool_account"
          id="pool_account"
          defaultValue=""
          value={poolBasket}
          label="Pool basket"
          onChange={(e) => {
            setPoolBasket(e.target.value);
          }}
        >
          {poolBasketOpt &&
            poolBasketOpt.map((el, i) => (
              <MenuItem key={i} value={el}>
                {el.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <Box sx={{ mt: 2 }}>
        <FormNumberInput
          name="amount"
          control={control}
          label={`Amount (Max: ${maxAmount})`}
          // min={0}
          max={maxAmount}
          rules={{
            required: "Please enter an amount!",
          }}
        />
      </Box>

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          type="submit"
          loading={fundPoolLoading}
        >
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default FundPoolForm;
